import useGetExaminationResultByLesson from './useGetExaminationResultByLesson';
import { formatScore } from './utils';

export { formatScore };
export default useGetExaminationResultByLesson;
